import React from "react";
import SupportPageLayout from "../components/layout/SupportPageLayout";

const ShippingInfoPage = () => {
  return (
    <SupportPageLayout
      title="Shipping Information"
      description="Clear delivery expectations reduce checkout hesitation. This page explains how JmoLux processes, ships and supports orders."
      path="/shipping-info"
    >
      <section>
        <h2 className="text-2xl font-light text-white">Processing time</h2>
        <p className="mt-3 leading-relaxed text-gray-300">
          Most orders are reviewed and prepared within 1 to 3 business days.
          During launches, holidays or high-volume periods, processing may take
          slightly longer.
        </p>
      </section>
      <section>
        <h2 className="text-2xl font-light text-white">Delivery windows</h2>
        <p className="mt-3 leading-relaxed text-gray-300">
          Domestic delivery timelines vary by location and shipping method. Once
          your order leaves the warehouse, you will receive tracking details so
          you can monitor the shipment.
        </p>
      </section>
      <section>
        <h2 className="text-2xl font-light text-white">Order support</h2>
        <p className="mt-3 leading-relaxed text-gray-300">
          If you need help with a shipment, contact{" "}
          <a className="text-amber-300 hover:text-amber-200" href="mailto:hello@jmolux.com">
            hello@jmolux.com
          </a>{" "}
          with your order details and we will review it.
        </p>
      </section>
    </SupportPageLayout>
  );
};

export default ShippingInfoPage;
